<template>
  <div class="install-prompt" v-if="showInstallPrompt">
    <div class="prompt-content">
      <div class="prompt-icon">
        <i class="pi pi-download"></i>
      </div>
      <div class="prompt-text">
        <h4>{{ $t('installPrompt.title') }}</h4>
        <p>{{ $t('installPrompt.description') }}</p>
      </div>
      <div class="prompt-actions">
        <Button
          :label="$t('installPrompt.install')"
          @click="installApp"
          class="p-button-sm p-button-primary"
        />
        <Button 
          icon="pi pi-times" 
          @click="dismissPrompt"
          class="p-button-text p-button-sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import Button from 'primevue/button'

export default {
  name: 'InstallPrompt',
  components: {
    Button
  },
  setup() {
    const showInstallPrompt = ref(false)
    const deferredPrompt = ref(null)

    onMounted(() => {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        deferredPrompt.value = e
        showInstallPrompt.value = true
      })

      window.addEventListener('appinstalled', () => {
        showInstallPrompt.value = false
        deferredPrompt.value = null
      })
    })

    const installApp = async () => {
      if (!deferredPrompt.value) return

      deferredPrompt.value.prompt()
      const { outcome } = await deferredPrompt.value.userChoice
      
      if (outcome === 'accepted') {
        showInstallPrompt.value = false
      }
      
      deferredPrompt.value = null
    }

    const dismissPrompt = () => {
      showInstallPrompt.value = false
      deferredPrompt.value = null
    }

    return {
      showInstallPrompt,
      installApp,
      dismissPrompt
    }
  }
}
</script>

<style scoped>
.install-prompt {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  border: 1px solid #e9ecef;
  z-index: 1000;
  max-width: 400px;
  margin: 0 auto;
}

.prompt-content {
  display: flex;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
}

.prompt-icon {
  font-size: 1.5rem;
  color: #1976d2;
}

.prompt-text {
  flex: 1;
}

.prompt-text h4 {
  margin: 0 0 0.25rem 0;
  font-size: 1rem;
  color: #212529;
}

.prompt-text p {
  margin: 0;
  font-size: 0.875rem;
  color: #6c757d;
}

.prompt-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

@media (max-width: 768px) {
  .install-prompt {
    left: 0.5rem;
    right: 0.5rem;
  }
}
</style>
